import delegate from "./delegate.js";
async function oneEvent(selector, type, options = {}) {
  return new Promise((resolve) => {
    options.once = true;
    if (options.signal?.aborted) {
      resolve(void 0);
    }
    options.signal?.addEventListener("abort", () => {
      resolve(void 0);
    });
    delegate(selector, type, resolve, options);
  });
}
export default oneEvent;
